var map = {
	"./chainmail_helmet.png": "920c",
	"./diamond_helmet.png": "b834",
	"./golden_helmet.png": "ff84",
	"./iron_helmet.png": "3389",
	"./netherite_helmet.png": "b781",
	"./pumpkin_helmet.png": "498b",
	"./rainbow_helmet.png": "a1ed",
	"./turtle_helmet.png": "23f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3541";